import {
  getReceived,
  deleteShare
} from '../service/received'
import {
    loadstars
} from '../service/latest'
import {
  pageCount
}
from '../../../src/config'
export default {
    namespaced: true,
    state(){
        return {
            fileList: [],
            initing: true,
            currentPage: 1,
            filter: 'all',
            maxPage: false,
            loading: false,
            route: ""
        }
    },
    mutations:{
        INIT(state,{noinit}) {
          !noinit ? state.fileList = [] : ''
          state.initing = !noinit
          state.currentPage = 1
          state.maxPage = false,
          state.loading = false
        },
        SAVE_FILES(state, {list,noinit}) {
          state.currentPage === 1 ? state.initing = false : null
          state.currentPage += 1
          state.maxPage = list.length < pageCount
          state.fileList = noinit ? list : state.fileList.concat(list)
        },
        LOADING(state, flag) {
            state.loading = flag
        },
        DOING(state, flag) {
          state.doing = flag
        },
        UPDATE_STAR(state, {
            sid,
            fileid,
            type
          }) {
            type == 'star' ? 
            state.fileList.map(item => item.sid == sid || item.fileid == fileid ? item.stared = 1 : '') :
            state.fileList.map(item => item.sid == sid || item.fileid == fileid ? item.stared = 0 : '')
        },
        UPDATE_TYPE(state,route){
            state.route = route
        }
    },
    actions:{
        flush({commit,dispatch},{noinit}){
            commit('INIT',{noinit})
            dispatch('loadmore',{noinit})
        },
        loadmore({commit,state},paload){
            if (state.maxPage || state.loading) {
              return
            }
            commit('LOADING', true)
            let offset = (state.currentPage - 1) * pageCount
            getReceived({
                count: pageCount,
                offset,
                type: state.route
            },({status,data}) => {
                if (status === 200) {
                    if(state.route == 'shared'){
                        let newdata = []
                        data.share.map(item => {
                            let info = {}
                            info.fileid = item.file.fileid
                            info.fileidstr = item.file.fileid.toString()
                            info.fromname = item.file.path
                            info.fromuid = item.share_creator.id
                            info.groupid = item.file.groupid
                            info.mtime = item.share_ctime * 1000
                            info.name = item.share_name
                            info.sid = item.link.sid
                            info.size = item.file.fsize
                            info.userid = item.share_creator.id
                            newdata.push(info)
                        })
                        data.linkslistinfos = newdata
                    }
                    let result = data.linkslistinfos 
                    var fileids = []
                    var sids=[]
                    if(state.route == 'shared'){
                        fileids = result.map(item => {
                            return item.fileid
                        })
                    }else{
                        sids = result.map(item => {
                            return item.sid
                        })
                    }
                    if (!sids.length && !fileids.length) {
                        commit('SAVE_FILES', {
                            list: [],
                            noinit: paload && paload.noinit
                        })
                        return
                    }
                    loadstars({sids,fileids},({status,data}) => {
                        if (status === 200) {
                            if(data.ids.length > 0){
                                result.map(item =>{
                                    data.ids.indexOf(item.fileid) > -1 ? item.stared = 1 : item.stared = 0
                                    return item
                                })
                            }else{
                                result.map(item => {
                                    data.sids.indexOf(item.sid) > -1 ? item.stared = 1 : item.stared = 0
                                    return item
                                })
                            }
                            commit('SAVE_FILES', {
                                list: result,
                                noinit: paload && paload.noinit
                            })
                        }else{
                            commit('SAVE_FILES', {
                              list: [],
                              noinit: paload && paload.noinit
                            })
                            commit('TOAST', {
                              type: 'error',
                              msg: data.result
                            }, {
                              root: true
                            })
                        }
                        commit('LOADING', false)
                    })
                }else{
                    commit('SAVE_FILES', {
                        list: [],
                        noinit: paload && paload.noinit
                    })
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                commit('LOADING', false)
            })
        },
        updateStar({commit},paload){
            commit('UPDATE_STAR',paload)
        },
        deleteFiles({commit,dispatch},{sid}){
            let sids = [sid]
            commit('DOING', true)
            deleteShare({
                sids
            },({status,data})=>{
                if (status === 200) {
                    commit('UPDATE_FILES', sid)
                    dispatch('close',{},{root:true})
                    commit('TOAST',{
                        type: 'success',
                        msg: 'deleteSucc'
                    },{root:true})
                    dispatch('flush',{noinit: true})
                }else{
                    commit('TOAST', {
                      type: 'error',
                      msg: data.result
                    }, {
                      root: true
                    })
                }
                commit('DOING', false)
            })
        },
        
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/received.js